import gql from 'graphql-tag'
import { gqlast } from '../graphqlParser'
import { Base64 } from 'js-base64'

/* Función para crear un plan (afiliación) */
const CREATE_PLAN = (plan) => {
    const newPlan = {
        name: plan.name,
        details: plan.details,
        welcomeMessage: plan.welcomeMessage,
        subcategory: plan.subcategory,
        planImage: plan.planImage,
        contactDetails: plan.contactDetails,
        faqs: formatFaqs(plan.faqs),
        tiers: plan.tiers,
        sponsors: plan.sponsors,
        socialMedia: plan.socialMedia,
        tags: plan.tags,
        extraFields: plan.extraFields ? plan.extraFields : [],
    }

    const newMutation = gqlast`mutation {
        createPlan(data:${newPlan}) {
           id
           name
        }
    }`
    return gql`${newMutation}`
}

/*Función para eliminar un plan (afiliación) */
const DELETE_PLAN = (id) => {
    const newMutation = gqlast`mutation {
        deletePlan(id:${id})
    }`
    return gql`${newMutation}`
}

/* Función para editar un plan (afiliación) */
const UPDATE_PLAN = (plan) => {
    const updatedPlan = {
        id: plan.id,
        name: plan.name,
        externalId: plan.externalId,
        details: plan.details,
        welcomeMessage: plan.welcomeMessage,
        subcategory: plan.subcategory,
        planImage: plan.planImage,
        contactDetails: plan.contactDetails,
        faqs: formatFaqs(plan.faqs),
        tiers: plan.tiers,
        sponsors: plan.sponsors,
        socialMedia: plan.socialMedia,
        tags: plan.tags,
        extraFields: plan.extraFields ? plan.extraFields : [],
    }
    const omitTypename = (key, value) => (key === '__typename' ? undefined : value)
    const newPayload = JSON.parse(JSON.stringify(updatedPlan), omitTypename)
    const newMutation = gqlast`mutation {
        updatePlan(data:${newPayload}) {
           id
           name
        }
    }`
    return gql`${newMutation}`
}

/* Función para formatear las preguntas frecuentes */
const formatFaqs = (faqs) => {
    let formattedFaqs = faqs.map((faq) => {
        faq.answer = Base64.encode(faq.answer)
        return faq
    })
    for (let i = 0; i < formattedFaqs.length; i++) {
        if (
            formattedFaqs[i].question == ''
        ) {
            formattedFaqs.splice(i, 1);
        }
    }
    return formattedFaqs
}


export { CREATE_PLAN, UPDATE_PLAN, DELETE_PLAN }